export default __webpack_public_path__ + "static/media/bumper-accept.5aa8d8c8.png";